import { signal } from '@preact/signals-react'

export const isEmptyEmbargoDate = signal(false)

export const embargoDateReportFormIsOpen = signal(false)
export const embargoDateSubmittedFilters = signal({})